import "./factoryCard.css";
import GraphicsRadius from "../graphicsRadius/GraphicRadius";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faGear } from '@fortawesome/free-solid-svg-icons'
const FactoryCard = (props)=>{

    return(
        <div className={`fc-container ${(props.oneCard == true) ? ("fc-one-container") : ("")}` }>
            <div className="fc-title">
                {props.description}
            </div>
            <div className="fc-description">
                <FontAwesomeIcon icon={faLocationDot}></FontAwesomeIcon> Setores: {props.numberDepartments} | <FontAwesomeIcon icon={faGear}></FontAwesomeIcon> Máquinas: {props.numberMachines}
            </div>
            <div className="fc-graphic">
                <GraphicsRadius legend={"OEE"} signal={"%"} backGraphic={100} data={props.oeeMedium.toFixed(2) ?? 0}></GraphicsRadius>
            </div>
            <div className="fc-variables-box">
                <div className="fc-text">
                    Indicadores individuais
                </div>
                <div className="fc-variables">
                    <span>
                        <GraphicsRadius size={"sm"} legend={"Performance"}  signal={"%"} backGraphic={100} data={props.performanceMedium.toFixed(2) ?? 0}></GraphicsRadius>
                    </span>
                    <span>
                        <GraphicsRadius size={"sm"}  legend={"Disponibilidade"} signal={"%"} backGraphic={100} data={props.disponibilityMedium.toFixed(2) ?? 0}></GraphicsRadius>
                    </span>
                    <span>
                        <GraphicsRadius size={"sm"} legend={"Qualidade"} signal={"%"} backGraphic={100} data={props.qualityMedium.toFixed(2) ?? 0}></GraphicsRadius>
                    </span>
                </div>
                    
            </div>
            <div className="fc-button">
                <Button onClick={()=>{props.openDepartments()}} className="full-size" disabled={!(props.numberDepartments > 0)}>Setores</Button>
            </div>
        </div>
    )

}

export default FactoryCard;